import React from 'react';
import PropTypes from 'prop-types';
import Carousel, { NextArrow, PreviousArrow } from '../carousel/carousel';

const PopularCategories = ({ containerType, data, inSPA, videoEnabled }) => {
    const { items } = data;

    // Do not allow container with items outside of range 1-3 or 6
    if (![1, 2, 3, 6].includes(items.length)) {
        return null;
    }

    const multiRow = items.length === 6;
    const slidesToShow = multiRow ? 1 : items.length;
    const singleItem = items.length === 1;

    const settings = {
        className: `${multiRow ? 'carousel--multi-row' : ''}`,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        initialSlide: 0,
        swipeToSlide: true,
        rows: multiRow ? 2 : 1,
        slidesPerRow: multiRow ? 3 : 1,
        nextArrow: (
            <NextArrow arrowClassName="btn btn-outline-dark btn-round" />
        ),
        prevArrow: (
            <PreviousArrow arrowClassName="btn btn-outline-dark btn-round" />
        ),
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: singleItem ? 1 : 2,
                    slidesPerRow: 1,
                    rows: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: singleItem ? 1 : 2,
                    slidesPerRow: 1,
                    arrows: false,
                    rows: 1
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesPerRow: 1,
                    arrows: false,
                    rows: 1
                }
            }
        ]
    };

    return (
        <Carousel
            data={data}
            settings={settings}
            containerType={containerType}
            videoEnabled={videoEnabled}
            inSPA={inSPA}
        />
    );
};

PopularCategories.propTypes = {
    data: PropTypes.shape({
        title: PropTypes.string,
        type: PropTypes.string,
        items: PropTypes.array.isRequired
    }).isRequired,
    inSPA: PropTypes.bool,
    videoEnabled: PropTypes.bool
};

export default PopularCategories;
